import styled from 'styled-components';
var Main = styled.main.withConfig({
  displayName: "Main",
  componentId: "pwnp8n-0"
})([""]);
export default Main;